export default {
      id: "warning_amber-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#warning_amber",
      toString: function () {
        return this.url;
      }
    }